import { Profile } from '../profile'

export enum IdentityEvent {
    EMAIL_VERIFIED = 'pnIdEmailVerified',
    FORM_VALIDATED= 'pnFormValidated', // fires when DCS form passed valdation
    IDENTITY_CHANGE = 'pnIdChange', // fires on any identity change event (session start/stop etc.)
    IDENTITY_INIT = 'pnIdInit', // fires immediately with locally-stored profile
    SESSION_INIT = 'pnIdSession', // fires when an SSO session is confirmed active/inactive
    IDENTITY_PROFILE_INIT = 'pnIdProfileInit', // profile initialized
    IDENTITY_SESSION_PROFILE_INIT = 'pnIdIdentitySessionProfileInit', // profile loaded
    NEW_LOGIN = 'pnNewLogin', // fires when there is a new login
    PROVIDER_ID_ASSIGNED = 'pnProviderIdAssigned', // fires when identity provider assigns an ID for the user
    LOGIN_MODAL_READY = 'pnLoginModalReady',
    MP_READY = 'pnMpReady', // fires when mParticle becomes available
    COMMENT_LOGIN = 'pnCommentLogin', // when someone wants to login from commenting
    COMMENT_LOGOUT = 'pnCommentLogout', // when someone wants to logout from commenting
    IDENTITY_SIGNOUT = 'pnIdSignOut',
    NEW_REGISTRATION = 'pnNewRegistration', // fires when a new user successfully registers
    IDENTITY_LOGIN = 'pnExplicitLogin', // fires on a callback from the SSO on explicit login
    IDENTITY_READY = 'pnIdReady', // fires when the profile is fully loaded (with adlite)
    IDENTITY_PROFILE_UPDATED = 'pnIdProfileUpdated', // fires when the profile is fully loaded with adlite after signin
    MP_LISTENS = 'mParictle_listeners_ready', // fires when mParticle listeners are initialized
    SET_SAILTHRU_COOKIE = 'SetSailthruCookie', // fires when user completed registration/login and analytics is ready
    SAVE_RECOMMENDATION_CATEGORIES = 'saveRecommendationCategories', // fires when saves recommendation categories
    RECOMMENDATION_CATEGORIES_SAVED_SUCCESS = 'recommendationCategoriesSavedSuccess', // recommendations saved
    RECOMMENDATION_CATEGORIES_SAVED_ERROR = 'recommendationCategoriesSavedError', // recommendations not saved
    OPEN_RECOMMENDATION_MODAL = 'openRecommendationModal', // Open recommendation Modal
}

export interface IIdentityEvent<T = Profile> extends CustomEvent<T> {
    detail: T
}
